const AgenteStatus = [
  {
    value: "ACD",
    label: "Activo - Con deuda"
  },{
    value: "SAP",
    label: "Suspendido - AAAPVER"
  }, {
    value: "SAT",
    label: "Suspendido actividades"
  },{
    value: "ACT",
    label: "Activo"
  }, {
    value: "CPA",
    label: "Cedio patente"
  },
  {
    value: "TRA",
    label: "En trámite"
  },
  {
    value: "FIN",
    label: "Finado"
  },
]

export default AgenteStatus